module.exports = __webpack_public_path__ + "img/9.9d398107.png";